import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import {
  GridColumn,
  GridRow,
  GridContainer,
  Carousel,
  LazyImg,
  Button,
} from "arv-reactcomponents";
import SelectedAddressText from "../../CheckoutComponents/SelectedAddressText";
import StoreAddressText from "../StoreAddressText";
import ConsignmentProduct from "../ConsignmentProduct";
import ConsignmentDelivery from "../ConsignmentDelivery";
import Anchor from "../../Anchor/index.js";
import { ORDERDETAILS } from "npmlinks-constants";

const {
  ORDER_DETAILS: {
    TRACKING_LINK,
    TRACKING_TITLE,
    DELIVERY_ADDRESS_TITLE,
    STORE_PICK,
  },
} = ORDERDETAILS;

class ConsignmentView extends PureComponent {
  get tracking() {
    const { consignment } = this.props;
    const { logisticsDetails } = consignment;
    if (logisticsDetails) {
      const { trackingLink, airwayBillNumber } = logisticsDetails;
      return (
        trackingLink && (
          <div className="nw-consignment-tracking">
            <div className="nw-consignment-trackingtitle">{TRACKING_TITLE}</div>
            <span className="nw-consignment-trackingnumber">
              {airwayBillNumber}
            </span>
            <Anchor.component
              className="nw-consignment-trackinglink"
              href={trackingLink}
              to={trackingLink}
              target="_blank"
            >
              {TRACKING_LINK}
            </Anchor.component>
          </div>
        )
      );
    }
  }
  get addressData() {
    const {
      addressDetails,
      ffType,
      returnAddrTitle = "",
    } = this.props.consignment;
    if (addressDetails) {
      if (ffType === STORE_PICK) {
        return (
          <Fragment>
            <StoreAddressText.component
              value={addressDetails}
              className="nw-consignment-addresstext"
              title={returnAddrTitle}
              showTitle
              isMobile
            />
          </Fragment>
        );
      }
      return (
        <Fragment>
          <SelectedAddressText.component
            value={addressDetails}
            className="nw-consignment-addresstext"
            isMobile={false}
            title={returnAddrTitle}
            showTitle
          />
        </Fragment>
      );
    }
  }
  render() {
    const { consignment, consignmentNumber = null, returnClick } = this.props;
    const {
      items,
      addressDetails,
      ffType,
      returnAddrTitle = DELIVERY_ADDRESS_TITLE,
    } = consignment;
    const { addressId } = addressDetails;
    const {
      itemDeliveryStates,
      itemDeliveryDateInfo,
      itemReturnStatesDetails,
    } = items && items[0];
    return (
      <Fragment>
        <GridRow className="nw-orderdetailspage-title">
          <GridColumn>
            <i className="icomoon-delivery-web nw-orderdetailspage-icon" />
            <div className="nw-orderdetailspage-titletext">{`#${consignmentNumber}: ${ffType}`}</div>
          </GridColumn>
        </GridRow>
        <GridRow className="nw-consignment">
          <ConsignmentProduct.component
            items={items}
            returnClick={returnClick}
            addressId={addressId}
          />
          <GridColumn className="nwc-grid-col-md nw-consignment-details">
            {this.addressData}
            <ConsignmentDelivery.component
              itemDeliveryStates={itemDeliveryStates}
              itemReturnStatesDetails={itemReturnStatesDetails}
              itemDeliveryDateInfo={itemDeliveryDateInfo}
            />
            {this.tracking}
          </GridColumn>
        </GridRow>
      </Fragment>
    );
  }
}

ConsignmentView.defaultProps = {
  consignment: [],
};

ConsignmentView.propTypes = {
  consignment: PropTypes.shape({}),
  consignmentNumber: PropTypes.number,
  returnClick: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ConsignmentView,
  component: ConsignmentView,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/OrderDetailsComponents/ConsignmentView/index.js